import * as React from 'react';
import HyperLinkRenderer from 'components/common/DataGridDevEx/CustomRenderers/HyperLinkRenderer';

const HyperLinkCell = ({ data }) => {

  return <HyperLinkRenderer value={{ FieldValue: data.value }} colDef={{ headerName: 'Descriptions' }} link={data.value} />;
};

export default HyperLinkCell;
